import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { IConstellationInfo } from "../../../../model/CarbonExternalModels";
import CreateConstellation from "../CreateConstellation";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { Button } from "userful-chronos-common-ui/dist";
import DeleteConstellation from "../delete/DeleteConstellation";

interface IProps {
    constellation: IConstellationInfo;
}

export default function ConstellationDropdown(props: IProps) {
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isConstellationSuppressor && !permissions.isConstellationCreator) return null;

    return (
        <>
            <Dropdown>
                <Dropdown.Toggle className="gcm-icon-dropdown-button" as={Button}>
                    <FontAwesomeIcon icon={faEllipsis} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                    className="userful-icon-dropdown-menu"
                    popperConfig={{ strategy: "fixed" }}
                    renderOnMount={true}
                >
                    <CreateConstellation
                        type={"DROPDOWN"}
                        constellation={props.constellation.definition}
                        permissions={permissions}
                    />
                    {permissions.isConstellationSuppressor && (
                        <DeleteConstellation
                            type={"DROPDOWN"}
                            constellations={{ [props.constellation.definition.id.value]: props.constellation }}
                        />
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}
